import type {
  CardLimite,
} from "@/components/settings/scripts/CardLimite";
import {
  HelperFunctions,
} from "@/scripts/Common/HelperFunctions";

const hasValue = (value: any) => {
    return !!value || value === 0;
}
const isEnabled = (state: boolean) => {
    return state
}

const isPositivNumber = (value: number) => value >= 0;

const isInCardLimite = (amount: number, cardLimite: CardLimite) => {
    if(amount < cardLimite.minCardLimit) return false;
    if(amount > cardLimite.maxCardLimit) return false;
    return amount <= cardLimite.topUpLimitPerMonth;
}

const hasCorrectDecimals = (amount: number, allowedDecimals: number) =>{
    return HelperFunctions.GetDecimalsCount(amount.toString()) <= allowedDecimals;
}

export {
    isEnabled,
    isInCardLimite,
    hasCorrectDecimals,
    hasValue,
    isPositivNumber
}
